import gql from 'graphql-tag'
export const LOGIN = gql`
        mutation Login($email: String!, $password: String!) {
                Login(email: $email, password: $password) {
                        accessToken
                }
        }
`
